import React, { useState } from 'react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Label } from '../../components/Label';
import api from '../../services/api';
import { toast } from 'sonner';

interface MenuNovoMaterialProps {
  onClose: () => void;
  onSuccess: () => void;
}

export const MenuNovoMaterial: React.FC<MenuNovoMaterialProps> = ({ onClose, onSuccess }) => {
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim()) {
      toast.error('Digite o nome do material');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/v1/materiais/', { nome });
      toast.success('Material cadastrado com sucesso!');
      setNome('');
      onSuccess();
      onClose();
    } catch (err) {
      toast.error('Erro ao cadastrar material');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="menu-novo-material-overlay">
      <div className="menu-novo-material">
        <h3 className="menu-novo-material-title">Novo Material</h3>
        <form onSubmit={handleSubmit}>
          <Label htmlFor="nome-material">Nome do material</Label>
          <Input
            id="nome-material"
            value={nome}
            onChange={e => setNome(e.target.value)}
            placeholder="Digite o nome"
            autoFocus
          />
          <div className="menu-novo-material-actions">
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Salvando...' : 'Cadastrar'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
